export default __webpack_public_path__ + "static/media/rudolph.70172f2e.mp3";